import React, { useState, useEffect } from 'react';
import defaultTitleImage from '../assets/Ellipse 38.svg'; 
import dash from '../assets/mage_dashboard-bar.svg';
import personal from '../assets/streamline_user-profile-focus.svg';
import booking from '../assets/icon-park-outline_tag.svg';
import disc from '../assets/streamline_discount-percent-coupon.svg';
import contact from '../assets/hugeicons_customer-support.svg';
import './UserNav.css';
import BASE_URL from '../config'; // Adjust the import path as necessary

import Dashboard from './Dashboard';
import PersonalInfo from './PersonalInfo';
import Bookings from './Bookings';
import Offers from './Offers';
import ContactSupport from './ContactSupport';

const UserNav = () => {
  const [activeSection, setActiveSection] = useState('dashboard');
  const [titleImage, setTitleImage] = useState(defaultTitleImage);

  // Fetch title image from backend, with fallback to default image
  useEffect(() => {
    const fetchTitleImage = async () => {
      try {
        const response = await fetch(`${BASE_URL}/api/user/title-image`); // Replace with actual API endpoint
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setTitleImage(data.image || defaultTitleImage);
      } catch (error) {
        console.log('Error fetching title image, using default:', error);
      }
    };

    fetchTitleImage();
  }, []);

  const navItems = [
    { id: 'dashboard', label: 'Dashboard', icon: dash, component: Dashboard },
    { id: 'personal', label: 'Personal Info', icon: personal, component: PersonalInfo },
    { id: 'bookings', label: 'Bookings', icon: booking, component: Bookings },
    { id: 'offers', label: 'Offers', icon: disc, component: Offers },
    { id: 'contact', label: 'Contact Support', icon: contact, component: ContactSupport }
  ];

  const ActiveComponent = navItems.find(item => item.id === activeSection)?.component || (() => null);

  return (
    <div className='user-nav-container'>
      <div className='user-navbar'>
        <div className='user-title-nav'>
          <div className='user-title-container'>
            <img src={titleImage} alt='User' />
            <div style={{fontWeight:'700'}}>Hello User</div>
          </div>
        </div>
        <div className='user-nav-tabs'>
          {navItems.map((item) => (
            <button
              key={item.id}
              className={`user-nav-item ${activeSection === item.id ? 'active' : ''}`} 
              onClick={() => setActiveSection(item.id)}
            >
              <img src={item.icon} alt={`${item.label} icon`} className='nav-icon' /> 
              <div className='user-nav-item-text'>{item.label}</div>
            </button>
          ))}
        </div>
      </div>
      <div className='user-content-area'>
        <ActiveComponent />
      </div>
    </div>
  );
};

export default UserNav;
